import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuperBidButtonComponent } from './super-bid-button.component';

const routes: Routes = [{ path: '', component: SuperBidButtonComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuperBidButtonRoutingModule { }
